
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type ProcessDropOnShiftPayload = {
  orderIds: EntityId[] | null
  sourceShiftId: EntityId | null
  shiftId: EntityId
  stopId: EntityId | null
  stopIds: EntityId[] | null
}

export const processDropOnShift = createAsyncThunk<void, ProcessDropOnShiftPayload, { state: RootState }>(
  'dragdrop/processDropOnShift',
  async ({ orderIds, sourceShiftId, shiftId, stopId, stopIds }, { getState }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/assignToShift' : '/runsheet/assignToShift'

    await OLMSApiService.post<null>(endpoint, {
      orderIds: orderIds,
      sourceShiftId: sourceShiftId,
      shiftId: shiftId,
      stopId: stopId,
      stopIds: stopIds,
    })
  },
)
